import { render } from "./TCheckbox.vue?vue&type=template&id=0112a95a"
import script from "./TCheckbox.vue?vue&type=script&lang=js"
export * from "./TCheckbox.vue?vue&type=script&lang=js"

import "./TCheckbox.vue?vue&type=style&index=0&id=0112a95a&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__